/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BipModel } from '../../models/bip-model';

export interface GetPatientBIPs$Params {
  patientID?: number;
}

export function GetPatientBIPs(http: HttpClient, rootUrl: string, params?: GetPatientBIPs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BipModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBIPs.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BipModel>>;
    })
  );
}

GetPatientBIPs.PATH = '/api/Staff/GetPatientBIPs';
